import { render, staticRenderFns } from "./ReportReques.vue?vue&type=template&id=9d0237f0&"
import script from "./ReportReques.vue?vue&type=script&lang=js&"
export * from "./ReportReques.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports